// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__XcwuH","opacity-transition":"success_opacity-transition__UC48O"};